module.exports = __webpack_public_path__ + "img/photo-27.98c48891.webp";